module.exports = __webpack_public_path__ + "static/media/parallax3.35ef8fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/parallax3.jpg
// module id = 96
// module chunks = 0